import React from 'react';

export const MessageWrapper = (props) => {
    return (<div style={{ backgroundColor: props.color }} className="message">{props.children}</div>)
}